module.exports = __webpack_public_path__ + "img/lea-47.26cad168.png";